app.factory("LocalStorageFactory", [
  "$localStorage",
  function ($localStorage) {
    return {
      isExpired(localStorageKey) {
        if ($localStorage[localStorageKey]) {
          let now = new Date();
          let val = JSON.parse($localStorage[localStorageKey]);
          if (now.getTime() > val.expiry) {
            this.remove(localStorageKey);
            return true;
          } else {
            return false;
          }
        } else {
          return true;
        }
      },

      update(localStorageKey, data) {
        $localStorage[localStorageKey] = JSON.stringify(data);
      },
      remove(localStorageKey) {
        delete $localStorage[localStorageKey];
      },
      getByKey(localStorageKey) {
        if ($localStorage[localStorageKey]) {
          if (typeof ($localStorage[localStorageKey]) === 'string') {
            return JSON.parse($localStorage[localStorageKey]);
          } else {
            return $localStorage[localStorageKey]
          }
        }
      },
    };
  },
]);
